import { render, staticRenderFns } from "./MenuSyncElement.vue?vue&type=template&id=3ca8467f"
import script from "./MenuSyncElement.vue?vue&type=script&lang=js"
export * from "./MenuSyncElement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports